import type { CreditDecisionOutcome } from '@paguz/contracts';
import type { PolicyRoute } from '../../api/origination-schemas.ts';

export const ROUTE_LABEL: Readonly<Record<PolicyRoute, string>> = {
  AUTO_APPROVE: 'Autoaprobación',
  AUTO_REJECT: 'Autorrechazo',
  ANALYST: 'Analista',
};

export const OUTCOME_LABEL: Readonly<Record<CreditDecisionOutcome, string>> = {
  APPROVED: 'Aprobar',
  COUNTER_OFFER: 'Contraoferta',
  REJECTED: 'Rechazar',
};

export const SECTION_LABEL: Readonly<Record<string, string>> = {
  SALES: 'Ventas',
  COGS: 'Costo de ventas',
  OPEX: 'Gastos del negocio',
  OTHER_INCOME: 'Otros ingresos',
  HOUSEHOLD: 'Gastos del hogar',
  DEBT: 'Cuotas vigentes',
  ASSET: 'Activos',
  LIABILITY: 'Pasivos',
};

export const LEGIBILITY: Readonly<Record<string, string>> = {
  GOOD: 'Buena',
  FAIR: 'Regular',
  POOR: 'Ilegible',
};
export const VALIDITY: Readonly<Record<string, string>> = {
  VALID: 'Vigente',
  EXPIRED: 'Vencido',
  UNKNOWN: 'Sin determinar',
};
export const RELEVANCE: Readonly<Record<string, string>> = {
  HIGH: 'Alta',
  MEDIUM: 'Media',
  LOW: 'Baja',
  NONE: 'Ninguna',
};
